import {
    DisclaimerLayerAppearanceV2,
    LayerCloseHandleV2,
} from '@volkswagen-onehub/layer-manager'
import React from 'react'
import {Provider} from 'react-redux'
import {store} from '../../../store'
import LegalNotesLayer from '../legalNotesLayer'
import {ThemedLayerProvider} from '../../../../shared/ThemedLayerProvider'

function configurationDataRenderLayer(
    // tslint:disable-next-line:no-any
    _state: any,
    // tslint:disable-next-line:no-any
    close: LayerCloseHandleV2<any>
): React.JSX.Element {
    return (
        <Provider store={store}>
            <ThemedLayerProvider theme="inverted">
                <LegalNotesLayer onCloseClick={() => close('layerContent')} />
            </ThemedLayerProvider>
        </Provider>
    )
}

// tslint:disable-next-line
export default function legalNotesLayerHandle(
    // tslint:disable-next-line:no-any
    layerManager: any,
    onClose: () => void
) {
    layerManager.openDisclaimerLayer(
        configurationDataRenderLayer,
        {},
        {
            appearance: DisclaimerLayerAppearanceV2.DARK,
            onClose,
        }
    )
}
